import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { StyledButtonSend } from './styles';
import ShareProposal from '../../../containers/ShareProposal';
import { share } from '../../../containers/Share/actions';
import { Api } from '../../../typings/api';
import UserAgentUtils from '../../../utils/userAgent';

interface ButtonSendProps {
	resourceId: number;
	label: string;
	isDisabled: boolean;
	driveItem: Api.DriveItem;
	dispatch: Dispatch<StoreState>;
}

const ButtonSend = ({ resourceId, label, isDisabled, driveItem, dispatch }: ButtonSendProps) => {
	const [isPopupDisplayed, setIsPopupDisplayed] = React.useState(false);

	const handleClick = () => {
		// Temporarily disable sending by-email on mobile devices
		if (UserAgentUtils.isMobileApp) {
			dispatch(share([driveItem], true));
		} else {
			setIsPopupDisplayed(true);
		}
	};

	return (
		<>
			<StyledButtonSend
				type="button"
				disabled={isDisabled}
				onClick={handleClick}
			>
				<Translate value="messages.send_it" />
			</StyledButtonSend>
			<ShareProposal
				resourceId={resourceId}
				label={label}
				isDisplayed={isPopupDisplayed}
				onCancel={() => setIsPopupDisplayed(false)}
			/>
		</>
	);
};

export default ButtonSend;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonSend/index.tsx